angular.module('rjmNg.directives').directive 'renderScalar', [
  "chartFormatterService"
  "$sce"
  "Figures"
  (chartFormatterService, $sce, Figures) ->
    restrict: "E"
    template: '''<div class="chartContainer">
        <div class="figure-content-scalar" ng-class="{'figure-content-scalar--hidden': !metric.plot}">
          <span class="scalar-value" bs-tooltip data-container="body" data-original-title="{{ dashboardItem.figure.presentation.scalar.truncate || dashboardItem.figure.presentation.scalar.truncate == undefined ? fullValue : ''}}" data-placement="right" ng-bind-html="bypassSanitize()">
          </span>
        </div>
      </div>
    '''
    replace: true
    scope: true
    priority: 300
    require: "^figure"
    controller: [
      "$scope"
      "$element"
      "$attrs"
      "reportQueryType"
      ($scope, $element, $attrs, reportQueryType) ->

        $scope.defaultTruncation = false
        $scope.reportQueryType = reportQueryType

        $scope.scalarFontSizer = (elementHeight) ->
          # get and set the initial font size to the height of the chart element
          # originally in ChartFormatterService
          fontSize = elementHeight * .7

          $element.find('span').css('font-size', fontSize)

        # In the event that we have a resizeFigurePresentation
        # directive, that directive can use this function.
        @resizeFunction = (width, height) ->
          scalarFontModifier = -10

          $scope.scalarFontSizer(height + parseInt(scalarFontModifier))

        # For some reason this was the only way to not have an ellipsis be appended
        # to our displayed adjustedValue when we used ng-bind-html...
        $scope.bypassSanitize = ->
          $sce.trustAsHtml($scope.adjustedValue)

        $scope.getScalarValueFromFigureData = (figure) ->
          figure.data.body[0]?[0]

        @
    ]
    link: (scope, elem, attrs, ctrl) ->
      _render = (figure) ->
        queryType = figure.reportQueryType
        switch queryType
          when scope.reportQueryType.SQL then _renderSql(figure)
          else _renderRjql(figure)

      _renderSql = (figure) ->
        value = scope.getScalarValueFromFigureData(figure)

        # if there is no value it means something went wrong
        # don't render anything in this case
        unless value?
          return

        # These are the same here, since we don't format SQL Scalars like in RJQL
        scope.adjustedValue = "#{value}"
        scope.fullValue = scope.adjustedValue
        scope.scalarFontSizer(elem.height())

      _renderRjql = (figure) ->
        heightModifier = attrs.heightModifier or= 0

        # range is just equal to the scalar. d'oh
        value = figure.data.rows[0].data[0][0]
        measureHeaders = figure.data.headers.measures[0]
        prefix = measureHeaders.prefix
        suffix = measureHeaders.suffix
        dataType = measureHeaders.dataType

        range =
          min: value
          max: value
        median = value

        if figure.presentation?.scalar?.truncate? then truncate = figure.presentation.scalar.truncate
        else truncate = scope.defaultTruncation

        if scope.$eval(attrs.allowFullValue) and not truncate
          scope.adjustedValue = chartFormatterService.getFormattedValue(value, prefix, suffix, dataType, range, median, true) # Show full value if on dashboard and truncation is off
        else
          scope.adjustedValue = chartFormatterService.getFormattedValue(value, prefix, suffix, dataType, range, median) # This is what's shown in the builder. It is formatted to fit a space with limited width.
        scope.fullValue = chartFormatterService.getFormattedValue(value, prefix, suffix, dataType, range, median, true) # The full value without truncation is used in a tooltip on hover.
        scope.scalarFontSizer(elem.height())

      scope.toggleTruncation = (figure, dashboardId = null) ->
        unless figure.reportQueryType is scope.reportQueryType.RJQL
          return

        scope.toggleTruncationRunning = true

        if figure.presentation.scalar.truncate?
          figure.presentation.scalar.truncate = not figure.presentation.scalar.truncate
        else
          figure.presentation.scalar.truncate = not scope.defaultTruncation

        updatedFigure = angular.extend({}, figure)
        updatedFigure.query = null

        Figures.save(updatedFigure).then((success) ->
          _render(updatedFigure)
          scope.toggleTruncationRunning = false
        , (error) ->
          scope.toggleTruncationRunning = false
          throw "Unable to save toggle truncated figure."
        )

      scope.$on "renderFigure", (event, figure) ->
        _render(figure)
]
